import { Box, Button, Callout, Dialog, Intent, Text } from "@blasterjs/core";
import React from "react";

import { DialogBody, DialogFooter, DialogHeader } from "../components/DialogLayout";
import ReasonForChange from "../components/ReasonForChange";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  closeArchiveImageDialog,
  imageArchive,
  setArchiveImageForm
} from "../slices/archiveImageDialog";
import { imagesFetch } from "../slices/images";

const archiveImageDialog = () => {
  const dispatch = useAppDispatch();
  const archiveImageDialog = useAppSelector(state => state.archiveImageDialog);

  const closeDialog = () => {
    dispatch(closeArchiveImageDialog());
  };

  const onConfirm = () => {
    archiveImageDialog.isOpen &&
      dispatch(imageArchive()).then(() => {
        if (archiveImageDialog.image.data.image.studyId) {
          dispatch(imagesFetch(archiveImageDialog.image.data.image.studyId));
        }
      });
  };

  const onChangeReasonForChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    archiveImageDialog.isOpen &&
      dispatch(
        setArchiveImageForm({
          ...archiveImageDialog.image.data,
          reasonForChange: e.target.value
        })
      );
  };

  const errorText =
    archiveImageDialog.isOpen && "errorMessage" in archiveImageDialog.image ? (
      <Box mb="2">
        <Callout intent={Intent.DANGER}>
          <Text>{archiveImageDialog.image.errorMessage}</Text>
        </Callout>
      </Box>
    ) : null;

  const confirmDisabled = !(
    archiveImageDialog.isOpen && archiveImageDialog.image.data.reasonForChange
  );
  return archiveImageDialog.isOpen ? (
    <Dialog isOpen={archiveImageDialog.isOpen} onRequestClose={closeDialog} appElementId="root">
      <DialogHeader title="Archive Image" closeDialog={closeDialog} />
      <DialogBody>
        {errorText}
        <Box>Are you sure you want to archive the following image file?</Box>
        <Box>
          <b>{archiveImageDialog.image.data.image.name}</b>
        </Box>
        <Box style={{ marginTop: 12 }}>
          Reason for Change*
          <ReasonForChange
            rkey="deleteImage_reason"
            value={
              (archiveImageDialog.isOpen && archiveImageDialog.image.data.reasonForChange) || ""
            }
            onChange={onChangeReasonForChange}
          />
        </Box>
      </DialogBody>
      <DialogFooter>
        <Button
          onClick={onConfirm}
          disabled={confirmDisabled}
          appearance="prominent"
          intent="danger"
        >
          Confirm
        </Button>
        <Button onClick={closeDialog}>Cancel</Button>
      </DialogFooter>
    </Dialog>
  ) : null;
};

export default archiveImageDialog;
